import React from 'react';
import { Card, CardHeader, CardContent } from './Card';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

interface FormCardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: LucideIcon;
  action?: React.ReactNode;
  contentClassName?: string;
}

export const FormCard = React.forwardRef<HTMLDivElement, FormCardProps>(
  ({ className, title, description, icon: Icon, action, contentClassName, children, ...props }, ref) => {
    return (
      <Card
        ref={ref}
        className={cn("border border-ui-hairline bg-ui-surface-card rounded-sm shadow-none", className)}
        {...props}
      >
        <CardHeader className="flex flex-row items-center gap-3 p-4 border-b border-ui-hairline bg-gradient-to-r from-blue-50 to-transparent dark:from-blue-950/20">
          {Icon && (
            <div className="w-8 h-8 rounded-sm bg-ui-primary-light flex items-center justify-center shrink-0 border border-ui-hairline">
              <Icon className="w-4 h-4 text-ui-primary" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-semibold text-ui-ink leading-tight">{title}</h2>
            {description && (
              <p className="text-xs text-ui-muted mt-0.5 leading-tight">{description}</p>
            )}
          </div>
          {action && (
            <div className="shrink-0 flex items-center">
              {action}
            </div>
          )}
        </CardHeader>
        <CardContent className={cn("p-4", contentClassName)}>
          {children}
        </CardContent>
      </Card>
    );
  }
);

FormCard.displayName = 'FormCard';
export default FormCard;
